import React, { useContext, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import LeftSidePopupLayout from "../../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../../component/icons/x-close";
import Style from "./style.module.css";
import { GlobalContext } from "../../../../../context/Context";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";
import moment from "moment";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
} from "../../../../../component/form/form-layout";
import Select from "react-select";

const WonDeal = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  wonFormDeal,
}) => {
  console.log(wonFormDeal);

  const { state, dispatch } = useContext(GlobalContext);
  const apiCall = useApiCall();

  const [paymentMethods, setPaymentMethods] = useState([]);
  const [merchants, setMerchants] = useState([]);

  // ✅ Fetch Payment Methods
  useEffect(() => {
    (async () => {
      try {
        const res = await apiCall({
          method: "get",
          url: "merchants/merchants-types-list",
        });
        setPaymentMethods(res?.data || []);
      } catch (err) {
        console.error("Payment methods fetch error:", err);
      }
    })();
  }, []);

  // ✅ Fetch Merchants List
  useEffect(() => {
    (async () => {
      try {
        const res = await apiCall({
          method: "get",
          url: "merchants/merchants-list",
        });
        setMerchants(res?.data || []);
      } catch (err) {
        console.error("Merchants list fetch error:", err);
      }
    })();
  }, []);

  const paymentOptions = paymentMethods?.map((pm) => ({
    value: pm.type_name,
    label: pm.type_name,
  }));

  const merchantsOptions = merchants?.map((m) => ({
    value: m.id,
    label: m.company_name,
  }));

  const validationSchema = yup.object({
    transaction_key: yup.string().required("This Field is Required"),
    payment_method: yup.string().required("This Field is Required"),
    merchant_id: yup.string().required("This Field is Required"),
    transaction_date: yup.string().required("This Field is Required"),
    transaction_time: yup.string().required("This Field is Required"),
  });

  const formik = useFormik({
    initialValues: {
      transaction_key: "",
      payment_method: "",
      merchant_id: "",
      transaction_date: "",
      transaction_time: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      let extraData = {};

      if (wonFormDeal?.dealkey) {
        extraData = {
          dealkey: wonFormDeal.dealkey,
          dealstatus: "won",
        };
      }

      const isAddonMeta = wonFormDeal?.metas?.find(
        (m) => m.meta_key === "is_addon"
      );
      const is_addon = isAddonMeta ? Number(isAddonMeta.meta_value) : 0;

      const data = {
        ...extraData,
        transaction_key: values.transaction_key,
        payment_method: values.payment_method,
        merchant_id: values.merchant_id,
        transaction_date: values.transaction_date,
        transaction_time: values.transaction_time,
        is_addon,
      };

      console.log("check", data);

      try {
        const apiRes = await apiCall({
          method: "post",
          url: `deals/update-deal-status`,
          data,
        });
        formik.resetForm();
        onSubmit(apiRes?.message, "won");
      } catch (error) {
        console.log("Error", error);
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.message ||
            "Something went wrong"
        );
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        <div
          className={`${Style.modal_header} ${Style.addMeModal_head} flex justify-between items-center`}
        >
          <h4>Won Deal</h4>
          <div
            onClick={onClose}
            className={`${Style.close_btn} cursor-pointer`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={Style.dcmb__card}>
            <div className={Style.dcmb__cardBody}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                <FormArea>
                  {/* Name */}
                  <FeildWraper>
                    <FormLabel required>Transaction Key</FormLabel>
                    <input
                      type="text"
                      name="transaction_key"
                      value={formik.values.transaction_key}
                      onChange={formik.handleChange}
                      placeholder="Transaction key"
                    />
                    {formik.touched.transaction_key &&
                      formik.errors.transaction_key && (
                        <FeildError>{formik.errors.transaction_key}</FeildError>
                      )}
                  </FeildWraper>

                  {/* Payment Merthod */}
                  <FeildWraper>
                    <FormLabel required>Payment Method</FormLabel>

                    <Select
                      name="payment_method"
                      isMulti
                      className="text-sm"
                      classNamePrefix="react-select"
                      options={paymentOptions}
                      components={{
                        IndicatorSeparator: () => null,
                        LoadingIndicator: () => null,
                      }}
                      value={paymentOptions.filter((option) =>
                        Array.isArray(formik.values.payment_method)
                          ? formik.values.payment_method.includes(option.value)
                          : false
                      )}
                      onChange={(selectedOptions) => {
                        const ids = selectedOptions.map((opt) => opt.value);
                        formik.setFieldValue("payment_method", ids);
                      }}
                      filterOption={(option, inputValue) =>
                        option.label
                          .toLowerCase()
                          .includes(inputValue.toLowerCase())
                      }
                      placeholder="Search or Select Payment Method..."
                      isClearable
                      menuPlacement="auto"
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: "35px",
                          height: "auto",
                          borderRadius: "5px",
                          border: "1px solid #DFDFDF",
                          backgroundColor: state.isDisabled
                            ? "#f0f0f0"
                            : "#FFF",
                          boxShadow: state.isFocused ? "none" : "none",
                          "&:hover": { borderColor: "#DFDFDF" },
                          fontSize: "13px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                          padding: "0 14px",
                          cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          height: "auto",
                          padding: "0 0px 0",
                        }),
                        input: (base) => ({
                          ...base,
                          margin: 0,
                          padding: 0,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                          height: "auto",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#717680",
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 99999,
                        }),
                        menu: (base) => ({
                          ...base,
                          marginTop: "2px",
                          borderRadius: "5px",
                          border: "1px solid #DFDFDF",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }),
                        option: (base, state) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: state.isSelected ? "#FFF" : "#1E1E1E",
                          backgroundColor: state.isSelected
                            ? "#3b82f6"
                            : state.isFocused
                            ? "#F3F4F6"
                            : "#FFF",
                          padding: "8px 14px",
                          cursor: "pointer",
                        }),
                        indicatorContainer: (base) => ({ ...base, padding: 0 }),
                        dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                      }}
                    />
                    {formik.touched.payment_method &&
                      formik.errors.payment_method && (
                        <FeildError>{formik.errors.payment_method}</FeildError>
                      )}
                  </FeildWraper>

                  {/* Merchant Name */}
                  <FeildWraper>
                    <FormLabel required>Merchant Name</FormLabel>

                    <Select
                      name="merchant_id"
                      isMulti
                      className="text-sm"
                      classNamePrefix="react-select"
                      options={merchantsOptions}
                      components={{
                        IndicatorSeparator: () => null,
                        LoadingIndicator: () => null,
                      }}
                      value={merchantsOptions.filter((option) =>
                        Array.isArray(formik.values.merchant_id)
                          ? formik.values.merchant_id.includes(option.value)
                          : false
                      )}
                      onChange={(selectedOptions) => {
                        const ids = selectedOptions.map((opt) => opt.value);
                        formik.setFieldValue("merchant_id", ids);
                      }}
                      filterOption={(option, inputValue) =>
                        option.label
                          .toLowerCase()
                          .includes(inputValue.toLowerCase())
                      }
                      placeholder="Search or Select Merchant..."
                      isClearable
                      menuPlacement="auto"
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: "35px",
                          height: "auto",
                          borderRadius: "5px",
                          border: "1px solid #DFDFDF",
                          backgroundColor: state.isDisabled
                            ? "#f0f0f0"
                            : "#FFF",
                          boxShadow: state.isFocused ? "none" : "none",
                          "&:hover": { borderColor: "#DFDFDF" },
                          fontSize: "13px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                          padding: "0 14px",
                          cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          height: "auto",
                          padding: "0 0px 0",
                        }),
                        input: (base) => ({
                          ...base,
                          margin: 0,
                          padding: 0,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                          height: "auto",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#717680",
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 99999,
                        }),
                        menu: (base) => ({
                          ...base,
                          marginTop: "2px",
                          borderRadius: "5px",
                          border: "1px solid #DFDFDF",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }),
                        option: (base, state) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: state.isSelected ? "#FFF" : "#1E1E1E",
                          backgroundColor: state.isSelected
                            ? "#3b82f6"
                            : state.isFocused
                            ? "#F3F4F6"
                            : "#FFF",
                          padding: "8px 14px",
                          cursor: "pointer",
                        }),
                        indicatorContainer: (base) => ({ ...base, padding: 0 }),
                        dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                      }}
                    />
                    {formik.touched.merchant_id &&
                      formik.errors.merchant_id && (
                        <FeildError>{formik.errors.merchant_id}</FeildError>
                      )}
                  </FeildWraper>

                  {/* /* Transaction Date */}
                  <FeildWraper>
                    <FormLabel required>Transaction Date</FormLabel>
                    <input
                      type="date"
                      name="transaction_date"
                      value={formik.values.transaction_date}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.transaction_date &&
                      formik.errors.transaction_date && (
                        <FeildError>
                          {formik.errors.transaction_date}
                        </FeildError>
                      )}
                  </FeildWraper>

                  {/* Transaction Time */}
                  <FeildWraper width="100%">
                    <FormLabel required>Transaction Time</FormLabel>
                    <input
                      type="time"
                      name="transaction_time"
                      value={formik.values.transaction_time}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.transaction_time &&
                      formik.errors.transaction_time && (
                        <FeildError>
                          {formik.errors.transaction_time}
                        </FeildError>
                      )}
                  </FeildWraper>
                </FormArea>
              </div>
            </div>
          </div>
        </div>

        <div className={Style.dcmb__cardFoot}>
          <button type="reset" className={Style.dcmb__cancel} onClick={onClose}>
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            Apply
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default WonDeal;
